import Logout from './logout';

export default Logout;
